import React from "react";

const CustomImageRadioDropdown = ({
  id,
  name,
  value,
  optionList,
  placeHolderText,
  debouncedFunction,
  handleSelectOption,
  isError,
}: any) => {
  const [open, setOpen] = React.useState(false);
  const [search, setSearch] = React.useState("");

  return (
    <>
      <style>
        {`
          .image-dropdown-wrapper {
            position: relative;
            width: 100%;
          }

          .image-dropdown-input {
            border: 1px solid #d1d1d1;
            padding: 10px;
            border-radius: 6px;
            cursor: pointer;
            background: #fff;
            width: 100%;
            display: flex;
            align-items: center;
          }

          .image-dropdown-input.error {
            border-color: red;
          }

          .placeholder {
            color: #999;
          }

          .selected-option {
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .dropdown-image {
            width: 35px;
            height: 35px;
            border-radius: 4px;
            object-fit: contain;
          }

          .dropdown-menu {
            position: absolute;
            width: 100%;
            background: white;
            border: 1px solid #cfcfcf;
            border-radius: 6px;
            max-height: 300px;
            overflow-y: auto;
            margin-top: 5px;
            z-index: 999;
          }

          .dropdown-search {
            width: 94%;
            padding: 8px;
            margin: 8px;
            border: 1px solid #ddd;
            border-radius: 4px;
          }

          .dropdown-list {
            padding: 4px;
          }

          .dropdown-option {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 8px;
            cursor: pointer;
            border-radius: 5px;
          }

          .dropdown-option:hover {
            background: #f3f3f3;
          }

          .no-data {
            padding: 10px;
            text-align: center;
            color: #777;
          }
        `}
      </style>

      {/* COMPONENT UI */}
      <div className="image-dropdown-wrapper">
        <div
          className={`image-dropdown-input ${isError ? "error" : ""}`}
          onClick={() => setOpen(!open)}
        >
          {value ? (
            <div className="selected-option">
              <img src={value.image} className="dropdown-image" />
              <span>{value.option}</span>
            </div>
          ) : (
            <span className="placeholder">{placeHolderText}</span>
          )}
        </div>

        {open && (
          <div className="dropdown-menu">
            {/* Search Box */}
            <input
              type="text"
              className="dropdown-search"
              placeholder="Search..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                debouncedFunction(e.target.value);
              }}
            />

            <div className="dropdown-list">
              {optionList.length === 0 ? (
                <div className="no-data">No Images Found</div>
              ) : (
                optionList.map((opt: any) => (
                  <div
                    key={opt.id}
                    className="dropdown-option"
                    onClick={() => {
                      handleSelectOption(opt);
                      setOpen(false);
                    }}
                  >
                    <input
                      type="radio"
                      checked={value?.id === opt.id}
                      readOnly
                    />
                    <img src={opt.image} className="dropdown-image" />
                    <span>{opt.option}</span>
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CustomImageRadioDropdown;
